export enum EnabledEnum {
    YES = 1,
    NO = 2
}
